module.exports = __webpack_public_path__ + "img/sword-fire-03.8d604432.png";